module.exports = __webpack_public_path__ + "img/collection-icon.f0cc80c1.png";